<template>
  <div v-parallax-fit="parallax" class="house" id="house-3">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/29_WhiteHouse.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 22500,
          end: 23000,
          fromStyle: { transform: 'translateX(50%) translateY(-250%) rotate(20deg)', marginTop: '0px' },
          toStyle: { transform: 'translateX(-50%) translateY(0%) rotate(0deg)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 24100,
          end: 24600,
          fromStyle: { transform: 'translateX(-50%) translateY(0%) rotate(0deg)', marginTop: '0px' },
          toStyle: { transform: 'translateX(-50%) translateY(115%) rotate(-15deg)', marginTop: '0px' },
          easing: 'linear'
        },
        {
          start: 24600,
          end: 25000,
          fromStyle: { transform: 'translateX(-50%) translateY(115%) rotate(-15deg)' },
          toStyle: { transform: 'translateX(-40%) translateY(300%) rotate(20deg)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/17.png',
          url: 'https://www.banking.senate.gov/hearings/how-private-equity-landlords-are-changing-the-housing-market',
          link_title: {
			'en': "How Private Equity Landlords are Changing the Housing Market ",
			'es': 'Cómo los propietarios de capital privado están cambiando el mercado de la vivienda'
		  },
        }
      ],
      text: {
		'en': `"We’ve called on Fannie Mae and Freddie Mac and their regulator, the FHFA, to add safeguards against rent and fee gouging, unfair evictions, and unsafe conditions in their manufactured home community financing. We need financing to support us – the residents – not passive investors. We want financing products that will allow nonprofits, public entities, and resident owned cooperatives to buy our communities and keep them affordable and healthy."`,
		'es': '"Le hemos pedido a Fannie Mae y Freddie Mac y a su regulador, la FHFA, que agreguen salvaguardas contra el aumento de tarifas y alquileres, los desalojos injustos y las condiciones inseguras en el financiamiento de su comunidad de casas prefabricadas. Necesitamos financiamiento para apoyarnos a nosotros, los residentes, no inversionistas pasivos. Queremos productos financieros que permitan a las organizaciones sin fines de lucro, las entidades públicas y las cooperativas de propiedad de los residentes comprar nuestras comunidades y mantenerlas asequibles y saludables".'
	  }
    };
    const text = {
		'en': `"Our Michigan communities are not alone and Havenpark is not the only actor treating residents this way, Holly said at the Senate Banking Committee Hearing. "Roughly 2 million people live in communities owned by the 50 largest community owners. Many operate like Havenpark, devastating seniors and families. And now some of the biggest private equity companies in the world are buying up mobile home parks."`,
		'es': '“Nuestras comunidades de Michigan no están solas y Havenpark no es el único actor que trata a los residentes de esta manera”, dijo Holly en la Audiencia del Comité Bancario del Senado. “Aproximadamente 2 millones de personas viven en comunidades propiedad de los 50 propietarios de comunidades más grandes. Muchos operan como Havenpark, devastando a personas mayores y familias. Y ahora algunas de las compañías de capital privado más grandes del mundo están comprando parques de casas móviles".'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateX(-40%) translateY(300%) rotate(20deg)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#house-3'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.house {
  position: absolute;
  bottom: 0%;
  left: 50%;
  max-width: 1000px;
  width: 100%;
  transition: all 0.1s linear;
}
</style>
